<p-dialog *ngIf="visible$ | async as visible"
#dialog
[header]="title"
[(visible)]="display"
[modal]="modal"
[appendTo]="appendTo"
[contentStyle]="{'overflow': 'auto', 'height': 'calc(100% - 120px)', 'position':'initial'}"
[responsive]="false"
[resizable]="false"
[draggable]="false"
[maximizable]="true"
[style]="style$ | async"
(onHide)="onHide()"
(onShow)="dialog.maximize()"
>
<ng-content></ng-content>
</p-dialog>